import { FieldHandler, BoardColumnConfig } from '../types';
import { convertConfigToSheetjs } from '../utils';

export type Config = BoardColumnConfig;

export const handler: FieldHandler<Config> = {
  defaultConfig: {},

  type: 'time_tracking',

  extractFieldsFromBoard: (board) => {
    return board.columns.flatMap((column) => {
      if (column.type === 'time_tracking') {
        return [
          {
            id: column.id,
            label: column.title,
          },
        ];
      }

      return [];
    });
  },

  exportTo: (outputFormat, fieldId, boardItem, board, config) => {
    const columnValue = boardItem.values.find(({ column_id }) => fieldId === column_id);

    if (!columnValue || columnValue.column_type !== 'time_tracking' || columnValue.value_type === 'error') {
      return null;
    }

    if (outputFormat === 'sheetjs') {
      return {
        ...convertConfigToSheetjs(config),
        v: columnValue.value.duration !== null ? columnValue.value.duration : undefined, // TODO: doublecheck if this works
        t: 'n',
      };
    }
  },
};

export default handler;
